const NON_PUBLIC_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0']);

// A localhost / non-public pageUrl gets stripped by Cloud Armor (track-*-public)
// before the event lands — this also covers the direct-sutro preview path, which
// resolves to localhost in-pod — so skip emitting analytics rather than fire
// events that never arrive.
// `skipAnalytics=1` is the track page's own opt-out, set on every load-test URL
// so synthetic traffic never lands in analytics; retail media events are
// analytics too.
export function willSkipAnalytics(pageUrl: string): boolean {
  try {
    const url = new URL(pageUrl);
    return (
      NON_PUBLIC_HOSTS.has(url.hostname) ||
      url.searchParams.get('skipAnalytics') === '1'
    );
  } catch {
    return false;
  }
}

// `x-original-url` is a localhost URL in-pod on non-prod stacks, so trusting it
// blindly suppressed every event on qa/st even when the customer was on a public
// host. Prefer the browser's own location whenever the server-provided URL does
// not describe where the customer actually is; genuine local development still
// resolves to localhost on both and still skips.
export function resolvePageUrl(requestUrl: string | undefined): string {
  const clientUrl = typeof window !== 'undefined' ? window.location.href : '';
  if (!requestUrl) return clientUrl;
  return willSkipAnalytics(requestUrl) && clientUrl ? clientUrl : requestUrl;
}
